export class Group {
  group = null;
  static setPosition(group, pos) {
    group.x(pos.x);
    group.y(pos.y);
  }

  createGroup(name) {
    this.group = new Konva.Group({
      draggable: false,
      name,
      //id: EditorService.generateUUID(),
    });
  }
}
